import { Alpine } from '../../../../vendor/livewire/livewire/dist/livewire.esm';

Alpine.directive('confirm', (el, { expression }, { evaluate, cleanup }) => {
    const detail = evaluate(expression)
    if (!detail || typeof detail !== 'object') {
        console.error('Alpine confirm directive: Invalid expression result', detail)
        return
    }

    const id = Math.random().toString(16).slice(2)
    el.setAttribute('id', id)

    if (detail.customActions?.length) {
        let events = []
        detail.customActions.forEach((action, index) => {
            events.push(() => evaluate(el.getAttribute(action.event)));
            window.addEventListener(action.event + '-' + id, events[index]);
        })
    } else {
        let confirmed = () => evaluate(el.getAttribute('confirmed'))
        let canceled = () => evaluate(el.getAttribute('canceled'))

        window.addEventListener('confirmed-' + id, confirmed);
        window.addEventListener('canceled-' + id, canceled);

        cleanup(() => {
            window.removeEventListener('confirmed-' + id, confirmed)
            window.removeEventListener('canceled-' + id, confirmed)
        })
    }


    el.addEventListener('click', () => {
        window.dispatchEvent(new CustomEvent('confirm', {
            detail: {
                title: detail.title,
                type: detail.type,
                description: detail.description,
                id: id,
                confirmLabel: detail.confirmLabel,
                cancelLabel: detail.cancelLabel,
                showCloseButton: detail.showCloseButton,
                customActions: detail.customActions,
            }
        }));
    })
})
